import {Command} from "commander";
import path from "path";
import chalk from "chalk";
import {camelCase, upperFirst} from "lodash/string";
import axios from "axios";

module.exports = function (program: Command) {
    program
        .command('dev:build')
        .option('-w, --watch', 'Watch for changes', false)
        .description('Build the server application using babel with @babel/preset-env, @babel/preset-flow and @babel/plugin-proposal-object-rest-spread')
        .action(async ({watch}) => {
            const babelOptions = {
                presets: [
                    "@babel/preset-env",
                    "@babel/preset-flow",
                    "@babel/preset-typescript",
                ],
                plugins: [
                    "@babel/plugin-transform-runtime",
                    "@babel/plugin-proposal-object-rest-spread",
                    "@babel/plugin-proposal-optional-chaining"
                ],
                sourceMaps: true
            };

            const cliOptions = {
                watch,
                outDir: path.join(process.cwd(), 'api', 'dist'),
                filenames: [path.join(process.cwd(), 'api', 'src')],
                extensions: ['.es6','.js','.es','.jsx','.mjs','.ts']
            };

            const r = await require('@babel/cli/lib/babel/dir').default({babelOptions, cliOptions});
            if (watch) await new Promise(r => {
            });
        });

    program
        .command('dev:scaffold')
        .description('Scaffold application structure')
        .action(cmd => {
            require('fs-extra').copySync(path.join(__dirname, 'templates', 'scaffold'), process.cwd())
        });
}
